import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PatientStyle from './doctor.module.scss';
import CustomTextField from '../components/form/CustomTextField';
import CustomSelectField from '../components/form/CustomSelectField';
import { toast } from 'react-toastify';
import { addDoctor, updateDoctor } from '../../apis/doctorSlice';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { getSpecialities } from '../../apis/doctorSpecialitySlice';
import SearchClinic from '../../components/Autocomplete/SearchClinic';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function DoctorDialog(props) {
  const { open, setOpen, editData, operationMode, setOperationMode, callApi } = props;
  const dispatch = useDispatch();

  // const { loading } = useSelector((state) => state.problemData);
  const { loading, specialities: specialityList } = useSelector(
    (state) => state.doctorSpecialityData,
  );

  const [doctorData, setDoctorData] = useState({
    name: '',
    email: '',
    phone: '',
    docSpeciality: '',
    clinicId: '',
    joiningDate: '',
  });

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [errors, setErrors] = useState({
  phone: '',
  email: '',
});
 const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const phoneRegex = /^[6-9]\d{9}$/;


  // React.useEffect(() => {
  //   if (
  //     editData &&
  //     Object.keys(editData) &&
  //     Object.keys(editData).length > 0 &&
  //     operationMode === 'Edit'
  //   ) {
  //     setDoctorData(editData);
  //     setUploadedFiles(editData.files || []);
  //   } else {
  //     setDoctorData({
  //       name: '',
  //       email: '',
  //       phone: '',
  //       docSpeciality: '',
  //       joiningDate: '',
  //     });
  //     setOperationMode('Add');
  //   }
  // }, [editData, operationMode]);

  React.useEffect(() => {
  if (
    editData &&
    Object.keys(editData) &&
    Object.keys(editData).length > 0 &&
    operationMode === 'Edit'
  ) {
    setDoctorData({
      ...editData,
      docSpeciality: editData.docSpeciality?._id || editData.docSpeciality || "", // ⭐ fix
      clinicId: editData.clinicId?._id || editData.clinicId || "",
    });
    setUploadedFiles(editData.files || []);
  } else {
    setDoctorData({
      name: '',
      email: '',
      phone: '',
      docSpeciality: '',
      clinicId: '',
      joiningDate: '',
    });
    setOperationMode('Add');
  }
}, [editData, operationMode]);


  React.useEffect(() => {
    if (open) {
      dispatch(getSpecialities());
    }
  }, [open]);

  const { loggedIn } = useSelector((state) => state.authData || {});

  // React.useEffect(() => {
  //   if (open && operationMode === 'Add' && loggedIn && loggedIn.clinicId) {
  //     setDoctorData((prev) => ({ ...prev, clinicId: loggedIn.clinicId }));
  //   }
  // }, [open, operationMode, loggedIn]);
  React.useEffect(() => {
  if (
    open &&
    operationMode === 'Add' &&
    loggedIn?.clinicId
  ) {
    setDoctorData((prev) => ({
      ...prev,
      clinicId: loggedIn.clinicId,
    }));
  }
}, [open, operationMode, loggedIn?.clinicId]);


  const handleClose = () => {
    setOpen(false);
    setDoctorData({
      name: '',
      email: '',
      phone: '',
      docSpeciality: '',
      joiningDate: '',
    });
    setUploadedFiles([]);
    setErrors({ phone: '', email: '' });
    setOperationMode('Add');
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files); // convert FileList → Array
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleOnChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;
  let errorMsg = '';

  // 👉 PHONE VALIDATION
  if (name === 'phone') {
    // allow only digits
    newValue = value.replace(/\D/g, '');

    // stop after 10 digits
    if (newValue.length > 10) return;

    // must start with 6-9
    if (newValue.length === 1 && !/[6-9]/.test(newValue)) {
      return; // block invalid first digit
    }

    if (newValue.length > 0 && !phoneRegex.test(newValue)) {
      errorMsg = 'Mobile must start with 6–9 and be 10 digits';
    }
  }

  // 👉 EMAIL VALIDATION (basic)
  if (name === 'email') {
    if (newValue && !emailRegex.test(newValue)) {
      errorMsg = 'Enter valid email';
    }
  }

  setDoctorData((prev) => ({ ...prev, [name]: newValue }));
  setErrors((prev) => ({ ...prev, [name]: errorMsg }));
};


  const handleSubmit = async () => {
    if (!doctorData.clinicId) {
      return toast.error('Please select clinic');
    }
    if (!doctorData.name) {
      return toast.error('Please enter name');
    }
    if (!doctorData.email) {
      return toast.error('Please enter email');
    }

     if (!emailRegex.test(doctorData.email)) {
  return toast.error('Enter valid email address');
}

    if (!doctorData.phone) {
      return toast.error('Please enter phone');
    }

    if (!phoneRegex.test(doctorData.phone)) {
  return toast.error('Enter valid 10 digit mobile starting with 6–9');
}


    if (!doctorData.docSpeciality) {
      return toast.error('Please select speciality');
    }

    // const formData = new FormData();
    // formData.append('name', doctorData.name);
    // formData.append('email', doctorData.email);
    // formData.append('phone', doctorData.phone);
    // formData.append('joiningDate', doctorData.joiningDate);
    // formData.append('docSpeciality', doctorData.docSpeciality);

    // uploadedFiles.forEach((file) => {
    //   doctorData.append('files', file);
    // });

    // const response = await dispatch(
    //   operationMode === 'Add'
    //     ? addDoctor(formData)
    //     : updateDoctor({ ...formData, id: doctorData._id }),
    // );


    const response = await dispatch(
      operationMode == 'Add'
        ? addDoctor(doctorData)
        : updateDoctor({ ...doctorData, id: doctorData._id }),
    );
    if (!response.payload?.success) {
      return toast.success(response.payload?.message);
    } else {
      handleClose();
      toast.success(response.payload?.message);
    }
   setErrors({ phone: '', email: '' });
    callApi();
  };

  const isDisabled =
  !doctorData.name.trim() ||
  !doctorData.email.trim() ||
  !doctorData.phone.trim() ||
  !doctorData.docSpeciality ||
  !!errors.email ||
  !!errors.phone;

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 2, border: '1px solid var(--color-border)' } }}
      >
        <DialogTitle sx={{ py: 1.1, px: 2, fontSize: '1rem', fontWeight: 800, color: 'var(--color-heading)' }}>
          {operationMode} Doctor
        </DialogTitle>
        <DialogContent sx={{ px: 2, pt: 0.2, pb: 1 }}>
          <div style={{marginTop:"5px"}}>
            <SearchClinic open={open} setData={setDoctorData} data={doctorData} name="clinicId" label="Clinic" size="small" />
          </div>
          <div style={{marginTop : "10px"}}>
            <CustomTextField
              label="Name"
              type="text"
              size="small"
              fullWidth
              className={PatientStyle.input}
              name="name"
              value={doctorData?.name}
              onChange={handleOnChange}
              required
            />
          </div>
          <div>
            <CustomTextField
              label="Email"
              type="email"
              size="small"
              fullWidth
              className={PatientStyle.input}
              name="email"
              value={doctorData?.email}
              onChange={handleOnChange}
               error={!!errors.email}
  helperText={errors.email}
              required
            />
          </div>
          <div>
            {/* <CustomTextField
              label="Phone"
              type="text"
              size="small"
              fullWidth
              className={PatientStyle.input}
              name="phone"
              value={doctorData?.phone}
              onChange={handleOnChange}
              required
               inputProps={{
                maxLength: 10,
                inputMode: 'numeric', // brings up numeric keypad on mobile
                pattern: '[0-9]*', // restricts to digits only
              }}
            /> */}
            <CustomTextField
  label="Phone"
  type="text"
  size="small"
  fullWidth
  className={PatientStyle.input}
  name="phone"
  value={doctorData?.phone}
  onChange={handleOnChange}
  required
  error={!!errors.phone}
  helperText={errors.phone}
  inputProps={{
    maxLength: 10,
    inputMode: 'numeric',
  }}
/>

          </div>
          
          <div style={{ marginBottom: '1rem' }}>
           
            <CustomSelectField
              id="docSpeciality"
              name="docSpeciality"
              value={doctorData?.docSpeciality || ''}
              onChange={handleOnChange}
              menuArr={(specialityList || []).map((sp) => ({
                label: sp.name,
                value: sp._id,
              }))}
              defultOpt={<option value="">Select Speciality</option>}
            />
          </div>
          <div>
            <CustomTextField
              label="Joining Date"
              type="date"
              size="small"
              fullWidth
              className={PatientStyle.input}
              name="joiningDate"
              value={doctorData?.joiningDate}
              onChange={handleOnChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1, gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleClose}
            color="inherit"
            sx={{ textTransform: 'none', borderColor: 'var(--color-border-soft)' }}
          >
            Cancel
          </Button>
       <LoadingButton
  loading={loading}
  variant="contained"
  size="small"
  onClick={handleSubmit}
  disabled={isDisabled}
  sx={{
    textTransform: 'none',
    minWidth: 92,
    background: isDisabled
      ? 'var(--gradient-disabled)'
      : 'var(--gradient-primary)',
  }}
>
  {operationMode === 'Edit' ? 'Update' : 'Submit'}
</LoadingButton>
          {/* <LoadingButton
            loading={loading}
            variant="contained"
            onClick={handleSubmit}
            className="dialogSubmitBtn"
            disabled={ !doctorData.name.trim() || !doctorData.email.trim() || !doctorData.phone.trim() || !doctorData.docSpeciality || !!errors.email || !!errors.phone }
          >
            Submit
          </LoadingButton> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
